import { render, staticRenderFns } from "./housekeepingServDetail.vue?vue&type=template&id=51b4c34a&scoped=true"
import script from "./housekeepingServDetail.vue?vue&type=script&lang=js"
export * from "./housekeepingServDetail.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServDetail.vue?vue&type=style&index=0&id=51b4c34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4c34a",
  null
  
)

export default component.exports